module.exports = __webpack_public_path__ + "img/TheoreticalPlan.588066a1.png";